import React from "react";

import { Box, Grid, Skeleton } from "@mui/material";

function AudiogramSkeleton() {
  return (
    <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid",
          borderColor: "divider",
          overflow: "hidden",
        }}
      >
        <Skeleton
          variant="rectangular"
          sx={{
            aspectRatio: "1/1",
            width: "100%",
            height: "auto",
            transform: "none",
          }}
        />
        <Box sx={{ p: 2, borderTop: "1px solid", borderColor: "divider" }}>
          <Skeleton variant="text" width="78%" height={20} sx={{ mb: 1 }} />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
            }}
          >
            <Skeleton
              variant="rounded"
              width={48}
              height={22}
              sx={{ borderRadius: "11px" }}
            />
            <Skeleton variant="text" width={72} height={16} />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}

export default function LoadingSkeletons() {
  return (
    <>
      {Array.from({ length: 8 }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <AudiogramSkeleton key={i} />
      ))}
    </>
  );
}
